const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/96197346-3905-4338-9f6f-545a4a9da490/images/a0b4ec6b810986b47458c5a74844fe9c560302faedef69c987d9a06e89928e8b.png";

function scrollToTarget(e, target) {
  e.preventDefault();
  document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
}

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] w-full overflow-hidden flex items-center pt-24 md:pt-28"
    >
      <HeroBackground />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 py-10 md:py-16">
        <HeroContent />
      </div>
    </section>
  );
}

function HeroBackground() {
  return (
    <div className="absolute inset-0">
      <img
        src={HERO_IMG}
        alt="Modern luxury interior with warm radiant light"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/30 to-black/75" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/15 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-1/3 warm-glow animate-glow-pulse pointer-events-none" />
    </div>
  );
}

function HeroContent() {
  return (
    <div className="max-w-3xl reveal">
      <h1
        className="font-display text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light tracking-[-0.02em] leading-[1.05] drop-shadow-[0_2px_24px_rgba(0,0,0,0.45)]"
        data-testid="hero-headline"
      >
        Invisible warmth.
        <br />
        <span className="font-light whitespace-nowrap">Exceptional comfort.</span>
      </h1>
      <p
        className="mt-8 text-white text-base md:text-lg max-w-xl leading-relaxed font-normal drop-shadow-[0_1px_12px_rgba(0,0,0,0.55)]"
        data-testid="hero-subheadline"
      >
        ecoHeatwave radiant heating systems integrate seamlessly within modern
        buildings—delivering invisible, energy-efficient warmth with no
        compromise on comfort or design.
      </p>
      <HeroCTAs />
    </div>
  );
}

function HeroCTAs() {
  return (
    <div className="mt-10 flex flex-wrap items-center gap-5">
      <a
        href="#design"
        onClick={(e) => scrollToTarget(e, "#design")}
        data-testid="hero-cta-discover"
        className="group inline-flex items-center gap-3 bg-ecoh-accent hover:bg-ecoh-accentHover text-white px-8 py-4 rounded-full font-medium tracking-wide transition-all duration-300 hover:-translate-y-0.5 hover:shadow-2xl shadow-black/20"
      >
        Discover ecoHeatwave
        <span className="transition-transform group-hover:translate-x-1">→</span>
      </a>
      <a
        href="#consultation"
        onClick={(e) => scrollToTarget(e, "#consultation")}
        data-testid="hero-cta-consult"
        className="inline-flex items-center gap-2 text-white/90 hover:text-white text-sm font-medium tracking-wide border-b border-white/30 hover:border-white pb-1 transition-all"
      >
        Book a consultation
      </a>
    </div>
  );
}
